module.exports = __webpack_public_path__ + "static/ziraat1-eef83265706c74b3c1495e7fac63118e.png";